module.exports = __webpack_public_path__ + "static/media/1009551.da868ff3.png";